(function () {
  'use strict';
  if (window.KnickerRecommendations) return;
  var requests = new WeakMap();
  function load(section) {
    var id = section.dataset.productId;
    var previous = requests.get(section);
    if (previous && previous.id === id) return previous.promise;
    var state = { id: id };
    requests.set(section, state);
    var url = new URL(section.dataset.url, window.location.origin);
    url.searchParams.set('product_id', id);
    url.searchParams.set('section_id', section.dataset.sectionId);
    url.searchParams.set('limit', '10');
    url.searchParams.set('intent', 'related');
    state.promise = fetch(url.toString(), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Recommendations unavailable');
      return response.text();
    }).then(function (html) {
      if (requests.get(section) !== state || !section.isConnected) return;
      var response = new DOMParser().parseFromString(html, 'text/html');
      var result = Array.from(response.querySelectorAll('[data-product-recommendations]')).find(function (node) {
        return node.dataset.sectionId === section.dataset.sectionId && node.dataset.productId === id;
      });
      var grid = result && result.querySelector('[data-recommendation-grid]');
      if (!grid || !grid.querySelector('[data-recommendation-product-id]')) return;
      if (section.contains(document.activeElement)) return;
      section.querySelector('[data-recommendation-grid]').innerHTML = grid.innerHTML;
      section.hidden = false;
    }).catch(function () { /* The collection fallback remains usable. */ });
    return state.promise;
  }
  function init(root) {
    var sections = [];
    if (root.matches && root.matches('[data-product-recommendations]')) sections.push(root);
    sections = sections.concat(Array.from(root.querySelectorAll('[data-product-recommendations]')));
    sections.forEach(function (section) {
      var current = window.product && window.product.product;
      if (current && current.id) section.dataset.productId = String(current.id);
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect();
            load(section);
          }
        }, { rootMargin: '300px' });
        observer.observe(section.hidden ? section.parentElement : section);
      } else load(section);
    });
  }
  document.addEventListener('knicker:product-change', function (event) {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (section) {
      if (section.dataset.productId === String(event.detail.id)) return;
      section.dataset.productId = String(event.detail.id);
      section.querySelectorAll('[data-recommendation-product-id]').forEach(function (card) {
        if (card.dataset.recommendationProductId === section.dataset.productId) card.remove();
      });
      if (!section.querySelector('[data-recommendation-product-id]')) section.hidden = true;
      load(section);
    });
  });
  window.KnickerRecommendations = { init: init, load: load };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
